import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';


const ACTIONS = createAsyncActions('SERVER.VIDEOS.REMOVE');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function remove(videoIds) {
  return function (dispatch) {
    dispatch(START({ videoIds }));

    return vodAdapter.items.remove(videoIds)
      .then(
        function (response) {
          dispatch(SUCCESS({ videoIds }, response));
          return response;
        },

        function (response) {
          dispatch(FAIL({ videoIds }, response, { analytics: { type: 'error', name: 'dashboard.videos.remove' } }));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/videos/remove.js